(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ikao-account-panel"]) return;
  try {
    
if(!customElements.get('ikao-account'))customElements.define('ikao-account',class extends HTMLElement{
  connectedCallback(){
    this.abort?.abort();this.abort=new AbortController();this.dialog=this.querySelector('dialog');this.opener=null;const signal=this.abort.signal;
    const logo=this.querySelector('.ia-logo');if(!logo.querySelector('img')){const original=document.querySelector('.ikao-logo-normal');if(original){const img=original.cloneNode(true);img.removeAttribute('class');logo.replaceChildren(img);}}
    document.addEventListener('click',e=>{const trigger=e.target.closest('[data-account-open]');if(trigger&&!e.defaultPrevented&&!e.metaKey&&!e.ctrlKey&&!e.shiftKey&&!e.altKey&&e.button===0){e.preventDefault();this.open(trigger);}},{signal});
    this.addEventListener('click',e=>{
      if(e.target.closest('[data-account-close]'))this.dialog.close();
      const tab=e.target.closest('[data-account-tab]');if(tab)this.select(tab);
      if(e.target.closest('[data-account-wishlist]')){const trigger=this.opener;this.dialog.close();document.dispatchEvent(new CustomEvent('ikao:wishlist:open',{detail:{trigger}}));}
      if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)this.dialog.close();}
    },{signal});
    this.addEventListener('keydown',e=>{const tabs=[...this.querySelectorAll('[data-account-tab]')];const i=tabs.indexOf(e.target);if(i<0)return;let next;if(e.key==='ArrowRight')next=(i+1)%tabs.length;if(e.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;if(e.key==='Home')next=0;if(e.key==='End')next=tabs.length-1;if(next!==undefined){e.preventDefault();this.select(tabs[next]);tabs[next].focus();}},{signal});
    this.dialog.addEventListener('close',()=>{this.opener?.setAttribute('aria-expanded','false');if(!document.querySelector('dialog[open]')){document.documentElement.classList.remove('ikao-modal-open');if(this.opener?.isConnected)this.opener.focus({preventScroll:true});}},{signal});
    document.addEventListener('shopify:section:select',e=>{if(e.target.contains(this))this.open();},{signal});
    document.addEventListener('shopify:section:deselect',e=>{if(e.target.contains(this)&&this.dialog.open)this.dialog.close();},{signal});
  }
  select(tab){this.querySelectorAll('[data-account-tab]').forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;});this.querySelectorAll('[data-account-pane]').forEach(p=>p.hidden=p.dataset.accountPane!==tab.dataset.accountTab);}
  open(trigger){
    if(this.dialog.open)return;this.opener=trigger||document.activeElement;
    document.querySelectorAll('ikao-header').forEach(h=>h.close?.(false));document.querySelectorAll('dialog[open]').forEach(d=>d.close());
    this.dialog.showModal();document.documentElement.classList.add('ikao-modal-open');this.opener?.setAttribute('aria-expanded','true');this.querySelector('[data-account-tab][aria-selected=true],.ia-primary')?.focus({preventScroll:true});
  }
  disconnectedCallback(){this.abort?.abort();if(this.dialog?.open)this.dialog.close();this.opener?.setAttribute('aria-expanded','false');if(!document.querySelector('dialog[open]'))document.documentElement.classList.remove('ikao-modal-open');}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-campaign"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ikao-home-campaign')) customElements.define('ikao-home-campaign',class extends HTMLElement{
    connectedCallback(){
      this.video=this.querySelector('video');if(!this.video)return;
      this.button=this.querySelector('.ikao-home-campaign__pause');this.button.hidden=false;
      this.mobile=matchMedia('(max-width:749px)');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.manual=null;this.visible=false;
      this.abort=new AbortController();const signal=this.abort.signal;
      this.update=()=>{const src=this.mobile.matches?this.video.dataset.mobile:this.video.dataset.desktop;if(this.video.getAttribute('src')!==src){this.video.src=src;this.video.load();}const play=this.visible&&!document.hidden&&(this.manual===true||(this.manual!==false&&this.dataset.autoplay==='true'&&!this.reduced.matches));if(play)this.video.play().catch(()=>this.sync());else this.video.pause();};
      this.sync=()=>{this.button.setAttribute('aria-label',this.video.paused?this.button.dataset.play:this.button.dataset.pause);this.button.querySelector('[data-video-symbol]').textContent=this.video.paused?'▶':'Ⅱ';};
      this.button.addEventListener('click',()=>{this.manual=this.video.paused;this.update();},{signal});
      this.video.addEventListener('play',this.sync,{signal});this.video.addEventListener('pause',this.sync,{signal});this.video.addEventListener('error',()=>{this.video.hidden=true;this.button.hidden=true;},{signal});
      this.mobile.addEventListener('change',this.update,{signal});this.reduced.addEventListener('change',this.update,{signal});document.addEventListener('visibilitychange',this.update,{signal});
      this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible||this.video.getAttribute('src'))this.update();},{threshold:.05});this.observer.observe(this);this.sync();
    }
    disconnectedCallback(){this.observer?.disconnect();this.abort?.abort();this.video?.pause();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-collection"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ikao-collection'))customElements.define('ikao-collection',class extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();const signal=this.abort.signal;this.dialog=this.querySelector('dialog');this.trigger=this.querySelector('[data-open-filters]');
      if(this.dialog&&typeof this.dialog.showModal==='function'){
        this.form=this.querySelector('.ikao-filter-form');this.dialog.append(this.form);this.querySelector('.ikao-filter-fallback').hidden=true;this.trigger.hidden=false;this.form.querySelector('[data-close-filters]').hidden=false;
        this.trigger.addEventListener('click',()=>{this.dialog.showModal();document.documentElement.classList.add('ikao-modal-open');},{signal});
        this.form.querySelector('[data-close-filters]').addEventListener('click',()=>this.dialog.close(),{signal});this.dialog.addEventListener('close',()=>{this.form.reset();if(!document.querySelector('dialog[open]')){document.documentElement.classList.remove('ikao-modal-open');this.trigger.focus();}},{signal});
        this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)this.dialog.close();}},{signal});
      }
      this.stockTail=this.querySelector('[data-stock-tail]')||document.createElement('div');this.stockTail.hidden=true;this.stockTail.dataset.stockTail='';this.append(this.stockTail);this.orderStockCards();
      this.addEventListener('ikao:collection:complete',()=>this.orderStockCards(true),{signal});
      this.addEventListener('click',async e=>{const link=e.target.closest('[data-load-more]');if(!link)return;e.preventDefault();if(this.loading)return;this.loading=true;link.setAttribute('aria-busy','true');const status=this.querySelector('[data-load-status]');status.textContent='';
        try{const response=await fetch(link.href,{signal,headers:{Accept:'text/html'}});if(!response.ok)throw Error();const html=new DOMParser().parseFromString(await response.text(),'text/html');const next=[...html.querySelectorAll('ikao-collection')].find(el=>el.dataset.sectionId===this.dataset.sectionId);if(!next?.querySelector('[data-collection-grid]'))throw Error();const cards=[...next.querySelectorAll('[data-collection-grid] > article')];const grid=this.querySelector('[data-collection-grid]');grid.append(...cards);const more=next.querySelector('[data-load-more]');if(more)link.href=more.href;else link.remove();this.orderStockCards();document.dispatchEvent(new CustomEvent('ikao:cards:refresh'));cards.find(card=>grid.contains(card))?.querySelector('a')?.focus({preventScroll:true});
        }catch(error){if(error.name!=='AbortError')status.textContent=this.dataset.loadError;}finally{this.loading=false;link.removeAttribute('aria-busy');}
      },{signal});
    }
    orderStockCards(complete=false){
      this.dataset.stockManaged='true';
      const grid=this.querySelector('[data-collection-grid]');
      const cards=[...this.stockTail.children,...grid.querySelectorAll(':scope > article')];
      const inStock=cards.filter(c=>c.dataset.originSoldOut!=='true');
      const soldOut=cards.filter(c=>c.dataset.originSoldOut==='true');
      grid.append(...inStock);
      if(!complete&&this.querySelector('[data-load-more]'))this.stockTail.append(...soldOut);
      else grid.append(...soldOut);
    }
    disconnectedCallback(){this.abort?.abort();if(this.dialog?.open){this.dialog.close();if(!document.querySelector('dialog[open]'))document.documentElement.classList.remove('ikao-modal-open');}}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-countdown"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ikao-countdown'))customElements.define('ikao-countdown',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();this.closed=false;this.finished=false;this.editor=this.dataset.editor==='true';
  this.end=this.toInstant(this.dataset.end,this.dataset.time);this.start=this.dataset.start?this.toInstant(this.dataset.start,this.dataset.startTime):null;
  this.storageKey='ikao-countdown:'+this.dataset.key+':'+this.dataset.end+':'+this.dataset.time+':'+this.dataset.zone;
  if(!this.editor&&this.dataset.closeDuration==='session'){try{this.closed=sessionStorage.getItem(this.storageKey)==='closed';}catch{}}
  this.querySelector('.icd-close')?.addEventListener('click',()=>{this.closed=true;this.hidden=true;clearInterval(this.interval);if(!this.editor&&this.dataset.closeDuration==='session'){try{sessionStorage.setItem(this.storageKey,'closed');}catch{}}},{signal:this.abort.signal});
  if(!Number.isFinite(this.end)||(this.dataset.start&&!Number.isFinite(this.start))||(this.start&&this.start>=this.end)){
   if(!this.editor)return;
   this.end=Date.now()+172800000;this.start=null;this.note('Editör örneği: geçerli bitiş tarihi ve saati girin. Mağazada geçerli tarih olmadan gösterilmez.');
  }
  this.tick();this.interval=setInterval(()=>{if(!document.hidden)this.tick();},1000);
  if(this.finished||this.closed)clearInterval(this.interval);
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)this.tick();},{signal:this.abort.signal});
 }
 toInstant(date,time){
  if(!/^\d{4}-\d{2}-\d{2}$/.test(date)||!/^\d{2}:\d{2}$/.test(time))return NaN;
  const [y,m,d]=date.split('-').map(Number),[h,n]=time.split(':').map(Number),utc=Date.UTC(y,m-1,d,h,n);
  const stamp=new Date(utc);if(stamp.getUTCFullYear()!==y||stamp.getUTCMonth()!==m-1||stamp.getUTCDate()!==d||h>23||n>59)return NaN;
  try{const fmt=new Intl.DateTimeFormat('en-GB',{timeZone:this.dataset.zone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
   const local=t=>{const p=Object.fromEntries(fmt.formatToParts(new Date(t)).filter(x=>x.type!=='literal').map(x=>[x.type,Number(x.value)]));return Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);};
   let instant=utc;for(let i=0;i<4;i++){const delta=utc-local(instant);if(!delta)return instant;instant+=delta;}return local(instant)===utc?instant:NaN;
  }catch{return NaN;}
 }
 note(message){const el=this.querySelector('.icd-editor');if(el){el.textContent=message;el.hidden=false;}}
 tick(){
  if(this.closed)return;const now=Date.now();if(this.start&&now<this.start){this.hidden=!this.editor;if(this.editor)this.note('Planlanan başlangıç henüz gelmedi. Bu görünüm yalnızca editörde gösterilir.');else return;}
  const ended=now>=this.end;this.hidden=ended&&this.dataset.expiry==='hide'&&!this.editor;
  if(ended){this.finished=true;clearInterval(this.interval);if(this.editor&&this.dataset.expiry==='hide')this.note('Süre doldu. Bölüm mağazada gizlidir.');}
  const message=ended&&this.dataset.expiry!=='zero';this.querySelector('[data-active-text]').hidden=message;this.querySelector('[data-expired-text]').hidden=!message;this.querySelector('.icd-timer').hidden=message;
  const link=this.querySelector('.icd-link');if(link)link.hidden=ended&&this.dataset.linkExpired!=='true';
  const seconds=Math.max(0,Math.ceil((this.end-now)/1000));const values={days:Math.floor(seconds/86400),hours:this.dataset.days==='true'?Math.floor(seconds/3600)%24:Math.floor(seconds/3600),minutes:Math.floor(seconds/60)%60,seconds:seconds%60};
  this.querySelectorAll('[data-unit]').forEach(el=>{const next=String(values[el.dataset.unit]).padStart(2,'0');if(el.textContent!==next)el.textContent=next;});
 }
 disconnectedCallback(){clearInterval(this.interval);this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-footer"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('ikao-footer'))customElements.define('ikao-footer',class extends HTMLElement{

  connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;this.mobile=matchMedia('(max-width:749px)');const sync=()=>{this.querySelectorAll('.if-column').forEach(d=>{d.open=!this.mobile.matches||this.dataset.mobileOpen==='true';d.querySelector('summary').tabIndex=this.mobile.matches?0:-1;});};sync();this.mobile.addEventListener('change',sync,{signal});this.addEventListener('click',e=>{if(!this.mobile.matches&&e.target.closest('.if-column summary'))e.preventDefault();},{signal});document.addEventListener('shopify:block:select',e=>{const d=e.target.closest('.if-column');if(d&&this.contains(d))d.open=true;},{signal});}

  disconnectedCallback(){this.abort?.abort();}

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-gims-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ikao-gims-hero'))customElements.define('ikao-gims-hero',class extends HTMLElement{
 connectedCallback(){this.abort=new AbortController();const signal=this.abort.signal;this.video=this.querySelector('[data-film-src]');this.toggle=this.querySelector('.gims-hero__toggle');this.dialog=this.querySelector('dialog');this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.visible=false;this.ready=false;this.manualPause=false;
 const canAuto=()=>!this.dialog?.open&&this.dataset.autoplay==='true'&&!this.reduced.matches&&!navigator.connection?.saveData;
 this.load=()=>{if(this.video&&!this.video.getAttribute('src')){this.video.src=this.video.dataset.filmSrc;this.video.muted=true;this.video.load();}};
 this.play=()=>{this.load();this.video?.play()?.catch(()=>{});};
 this.update=()=>{if(!this.video)return;this.toggle.textContent=this.video.paused?'▶':'Ⅱ';this.toggle.setAttribute('aria-label',this.video.paused?this.dataset.play:this.dataset.pause);};
 if(this.video){this.video.addEventListener('playing',()=>{this.video.classList.add('is-ready');this.update();},{signal});this.video.addEventListener('pause',this.update,{signal});this.video.addEventListener('error',()=>this.video.classList.remove('is-ready'),{signal});this.toggle.addEventListener('click',()=>{if(this.video.paused){this.manualPause=false;this.play();}else{this.manualPause=true;this.video.pause();}},{signal});this.observer=new IntersectionObserver(es=>{this.visible=es[0].isIntersecting;if(this.visible&&this.ready&&canAuto()&&!this.manualPause&&!document.hidden)this.play();else this.video.pause();},{threshold:.25});this.observer.observe(this);const defer=()=>{this.timer=setTimeout(()=>{this.ready=true;if(this.visible&&canAuto()&&!this.manualPause&&!document.hidden)this.play();},Number(this.dataset.delay)||2000);};if(document.readyState==='complete')defer();else window.addEventListener('load',defer,{once:true,signal});document.addEventListener('visibilitychange',()=>{if(document.hidden)this.video.pause();else if(this.visible&&this.ready&&canAuto()&&!this.manualPause)this.play();},{signal});}
 if(this.dialog){const full=this.dialog.querySelector('video');this.querySelector('[data-film-open]').addEventListener('click',()=>{this.video?.pause();if(!full.getAttribute('src'))full.src=full.dataset.fullSrc;document.querySelectorAll('ikao-header').forEach(h=>h.close?.(false));this.dialog.showModal();document.documentElement.classList.add('ikao-modal-open');full.play()?.catch(()=>{});},{signal});this.querySelector('[data-film-close]').addEventListener('click',()=>this.dialog.close(),{signal});this.dialog.addEventListener('close',()=>{full.pause();if(!document.querySelector('dialog[open]'))document.documentElement.classList.remove('ikao-modal-open');if(this.visible&&this.ready&&canAuto()&&!this.manualPause)this.play();},{signal});}
 }
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.observer?.disconnect();if(this.dialog?.open)this.dialog.close();if(!document.querySelector('dialog[open]'))document.documentElement.classList.remove('ikao-modal-open');this.querySelectorAll('video').forEach(v=>{v.pause();v.removeAttribute('src');v.load();});}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-gims-product-story"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ikao-gims-product'))customElements.define('ikao-gims-product',class extends HTMLElement{
 connectedCallback(){const v=this.querySelector('video');if(!v||this.observer)return;const button=this.querySelector('[data-play]');const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;const saving=navigator.connection?.saveData;this.observer=new IntersectionObserver(entries=>{for(const e of entries){if(e.isIntersecting){if(!v.hasAttribute('src')&&!saving){v.src=v.dataset.film;v.load();if(button)button.hidden=true}if(this.dataset.autoplay==='true'&&!reduced&&!saving)v.play().catch(()=>{})}else v.pause()}},{threshold:.2});this.observer.observe(v);this.start=()=>{if(!v.hasAttribute('src')){v.src=v.dataset.film;v.load();if(button)button.hidden=true;v.play().catch(()=>{})}};v.addEventListener('click',this.start);button?.addEventListener('click',this.start)}
 disconnectedCallback(){this.observer?.disconnect();this.observer=null;const v=this.querySelector('video');v?.pause();v?.removeEventListener('click',this.start);this.querySelector('[data-play]')?.removeEventListener('click',this.start)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-header"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('ikao-header')) {

  customElements.define('ikao-header', class extends HTMLElement {

    connectedCallback() {

      this.abort = new AbortController();

      this.layer = this.querySelector('.ikao-layer');

      this.panel = this.querySelector('.ikao-panel');

      this.previousInert = new Map();

      this.active = null;

      const signal = this.abort.signal;

      this.addEventListener('click', event => {

        const opener = event.target.closest('[data-panel-open]');

        const switcher = event.target.closest('[data-panel-switch]');

        if (opener) {

          if (event.detail > 0 && this.dataset.hover === 'true' && opener.matches('.ikao-desktop-tab') && this.active === opener.dataset.panelOpen) return;

          if (this.active === opener.dataset.panelOpen || (this.active && opener.classList.contains('ikao-mobile-toggle'))) this.close();

          else this.open(opener.dataset.panelOpen, opener);

        }

        if (switcher) this.open(switcher.dataset.panelSwitch, this.lastOpener);

        if (event.target.closest('[data-panel-close]')) this.close();

        const wishlist = event.target.closest('[data-wishlist-open]');

        if (wishlist) this.dispatchEvent(new CustomEvent('ikao:wishlist:open', {bubbles:true, detail:{trigger:wishlist}}));

        if (this.active && event.target.closest('.ikao-menu-body a')) this.close(false);

      }, {signal});

      this.addEventListener('keydown', event => {

        if (!this.active) return;

        if (event.key === 'Escape') { event.preventDefault(); this.close(); }

        if (event.key !== 'Tab') return;

        const focusable = [...this.panel.querySelectorAll('a[href],button:not([disabled]),select,summary,[tabindex="0"]')].filter(el => el.getClientRects().length && !el.closest('[hidden]'));

        const first = focusable[0], last = focusable.at(-1);

        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.panel)) { event.preventDefault(); last?.focus(); }

        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }

      }, {signal});

      this.querySelectorAll('.ikao-desktop-tab').forEach(button => button.addEventListener('pointerenter', event => {

        if (this.dataset.hover !== 'true' || event.pointerType !== 'mouse' || !matchMedia('(min-width:750px)').matches) return;

        clearTimeout(this.hoverTimer);

        clearTimeout(this.hoverCloseTimer);

        this.hoverTimer = setTimeout(() => this.open(button.dataset.panelOpen, button, false), 100);

      }, {signal}));

      this.querySelectorAll('.ikao-desktop-tab').forEach(button => button.addEventListener('pointerleave', () => clearTimeout(this.hoverTimer), {signal}));

      [this.panel, ...this.querySelectorAll('.ikao-desktop-tab')].forEach(area => {

        area.addEventListener('pointerenter', () => clearTimeout(this.hoverCloseTimer), {signal});

        area.addEventListener('pointerleave', event => {

          if (this.dataset.hover !== 'true' || event.pointerType !== 'mouse' || !matchMedia('(min-width:750px)').matches || !['primary','secondary'].includes(this.active)) return;

          clearTimeout(this.hoverCloseTimer);

          this.hoverCloseTimer = setTimeout(() => {

            if (this.panel.matches(':hover') || this.querySelector('.ikao-desktop-tab:hover')) return;

            this.close(false);

          }, 180);

        }, {signal});

      });

      this.querySelectorAll('.ikao-menu-list > li > .ikao-subnav').forEach(details => details.addEventListener('toggle', () => {

        if (!details.open) return;

        details.closest('.ikao-menu-list').querySelectorAll(':scope > li > .ikao-subnav').forEach(other => { if (other !== details) other.open = false; });

      }, {signal}));

      this.resizeObserver = new ResizeObserver(() => this.measure());

      this.resizeObserver.observe(this);

      window.addEventListener('resize', () => this.measure(), {signal});

      this.lastScrollY = Math.max(0, window.scrollY);

      this.scrollTravel = 0;

      this.scrollDirection = 0;

      this.addEventListener('focusin', () => this.classList.remove('is-scroll-hidden'), {signal});

      window.addEventListener('scroll', () => {

        if (this.scrollFrame) return;

        this.scrollFrame = requestAnimationFrame(() => {

          this.scrollFrame = null;

          this.updateScroll();

        });

      }, {passive:true, signal});

      document.addEventListener('shopify:section:unload', event => {

        if (event.target.contains(this)) this.close(false);

      }, {signal});

      document.addEventListener('shopify:block:select', event => {

        const block = event.target.closest('.ikao-campaign, .ikao-menu-list li, .ikao-featured-menu a');
        if (!block || !this.contains(block)) return;

        const group = block.closest('[data-menu]');

        if (group) this.open(group.dataset.menu, null, false);

      }, {signal});

      this.classList.toggle('is-scrolled', window.scrollY > 20);

      this.measure();

    }

    updateScroll() {

      const y = Math.max(0, Math.min(window.scrollY, document.documentElement.scrollHeight - window.innerHeight));

      const delta = y - this.lastScrollY;

      this.lastScrollY = y;

      this.classList.toggle('is-scrolled', y > 20);

      if (this.active || document.documentElement.style.overflow === 'hidden' || document.documentElement.classList.contains('ikao-modal-open')) {

        this.classList.remove('is-scroll-hidden');

        this.scrollTravel = 0;

        return;

      }

      if (this.dataset.sticky !== 'true' || this.dataset.scrollHide !== 'true' || y < 32) {

        this.classList.remove('is-scroll-hidden');

        this.scrollTravel = 0;

        return;

      }

      const direction = Math.sign(delta);

      if (!direction) return;

      if (direction !== this.scrollDirection) this.scrollTravel = 0;

      this.scrollDirection = direction;

      this.scrollTravel += Math.abs(delta);

      if (direction < 0 && this.scrollTravel >= 3) this.classList.remove('is-scroll-hidden');

      else if (direction > 0 && this.scrollTravel >= 16 && !this.querySelector(':focus-visible')) this.classList.add('is-scroll-hidden');

    }

    measure() {

      const bottom = Math.max(0, this.querySelector('.ikao-header-bar').getBoundingClientRect().bottom);

      this.style.setProperty('--ikao-top', `${Math.round(bottom)}px`);

    }

    open(name, opener, focus = true) {

      if (!this.querySelector(`[data-menu="${name}"]`)) return;

      clearTimeout(this.closeTimer);

      clearTimeout(this.hoverTimer);

      clearTimeout(this.hoverCloseTimer);

      if (!this.active) {

        this.lastOpener = opener || document.activeElement;

        this.previousOverflow = document.documentElement.style.overflow;

        document.documentElement.style.overflow = 'hidden';

        let node = this;

        while (node.parentElement && node.parentElement !== document.documentElement) {

          for (const sibling of node.parentElement.children) {

            if (sibling !== node && !['STYLE','SCRIPT','LINK'].includes(sibling.tagName)) {

              this.previousInert.set(sibling, sibling.inert);

              sibling.inert = true;

            }

          }

          node = node.parentElement;

        }

      }

      this.active = name;

      this.classList.remove('is-scroll-hidden');

      if (opener?.matches?.('[data-panel-open]')) this.lastOpener = opener;

      this.layer.hidden = false;

      this.layer.dataset.active = name;

      this.classList.add('is-open');

      this.querySelectorAll('[data-menu]').forEach(menu => { menu.hidden = menu.dataset.menu !== name; });

      this.querySelectorAll('[data-panel-open]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.panelOpen === name || button.classList.contains('ikao-mobile-toggle'))));

      this.querySelectorAll('[data-panel-switch]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.panelSwitch === name)));

      const label = this.querySelector(`[data-menu="${name}"]`).dataset.title;

      this.querySelector('[data-panel-title]').textContent = label;

      this.panel.setAttribute('aria-label', label);

      this.measure();

      this.frame = requestAnimationFrame(() => {

        this.layer.classList.add('is-visible');

        if (focus) this.panel.focus({preventScroll:true});

      });

    }

    close(restoreFocus = true) {

      clearTimeout(this.hoverCloseTimer);

      clearTimeout(this.hoverTimer);

      if (!this.active) return;

      cancelAnimationFrame(this.frame);

      this.active = null;

      this.classList.remove('is-open');

      this.layer.classList.remove('is-visible');

      this.querySelectorAll('[data-panel-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));

      document.documentElement.style.overflow = this.previousOverflow || '';

      this.previousInert.forEach((value, element) => { element.inert = value; });

      this.previousInert.clear();

      if (restoreFocus && this.lastOpener?.isConnected) this.lastOpener.focus({preventScroll:true});

      const duration = matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : parseFloat(getComputedStyle(this).getPropertyValue('--ikao-motion')) || 0;

      this.closeTimer = setTimeout(() => { if (!this.active) this.layer.hidden = true; }, duration);

    }

    disconnectedCallback() {

      this.close(false);

      this.abort?.abort();

      this.resizeObserver?.disconnect();

      clearTimeout(this.closeTimer);

      clearTimeout(this.hoverTimer);

      cancelAnimationFrame(this.frame);

      clearTimeout(this.hoverCloseTimer);

      cancelAnimationFrame(this.scrollFrame);

    }

  });

}




  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-information"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ikao-information'))customElements.define('ikao-information',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;const menu=this.querySelector('.ii-topics');if(menu){const mq=matchMedia('(max-width:749px)');const sync=()=>{menu.open=!mq.matches;menu.querySelector('summary').tabIndex=mq.matches?0:-1;};sync();mq.addEventListener('change',sync,{signal});menu.querySelector('summary').addEventListener('click',e=>{if(!mq.matches)e.preventDefault();},{signal});}
 const content=this.querySelector('[data-information-content]');if(!content)return;
 // Some legacy policy HTML contains stripped style tags, leaving CSS as a text node.
 // Remove only whole formatting-only nodes; do not alter document prose or stored policy data.
 const walker=document.createTreeWalker(content,NodeFilter.SHOW_TEXT);const nodes=[];while(walker.nextNode())nodes.push(walker.currentNode);nodes.forEach(n=>{if(n.parentElement.closest('style,script,pre,code'))return;const s=n.textContent.trim();if(/^```(?:html|css)?\s*$/i.test(s)||(/^\.ikao-(?:policy|terms|legal|contact)-[\w-]+\s*\{/.test(s)&&/\}\s*$/.test(s))){n.textContent='';}});
 const toc=this.querySelector('[data-toc]');if(toc){const links=toc.querySelector('[data-toc-links]');links.replaceChildren();const existing=content.querySelector('.ikao-legal-page__summary-inner,.ikao-terms-page__summary-inner');const headings=[...content.querySelectorAll('h2')].filter(h=>h.textContent.trim());if(headings.length>1&&!existing){headings.forEach((h,i)=>{if(!h.id){let id=this.id+'-heading-'+i;while(document.getElementById(id))id+='-x';h.id=id;}const a=document.createElement('a');a.textContent=h.textContent.trim();a.href='#'+encodeURIComponent(h.id);links.append(a);});toc.hidden=false;}}
 }
 disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-marquee"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ikao-marquee')) {
  customElements.define('ikao-marquee', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.viewport = this.querySelector('.ikao-marquee__viewport');
      this.track = this.querySelector('.ikao-marquee__track');
      this.group = this.querySelector('[data-marquee-group]');
      this.original = this.querySelector('[data-marquee-original]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.mobile = matchMedia('(max-width: 749px)');
      this.toggle = this.querySelector('[data-marquee-toggle]');
      this.toggle?.addEventListener('click', () => {
        const paused = this.dataset.paused !== 'true';
        this.dataset.paused = String(paused);
        this.toggle.setAttribute('aria-pressed', String(paused));
        this.toggle.setAttribute('aria-label', paused ? this.toggle.dataset.playLabel : this.toggle.dataset.pauseLabel);
        this.toggle.querySelector('[data-pause-icon]').hidden = paused;
        this.toggle.querySelector('[data-play-icon]').hidden = !paused;
      }, {signal});
      this.querySelector('[data-marquee-close]')?.addEventListener('click', () => { this.hidden = true; }, {signal});
      this.addEventListener('focusout', () => this.queueBuild(), {signal});
      document.addEventListener('shopify:block:select', event => {
        if (this.contains(event.target)) { this.dataset.paused = 'true'; }
      }, {signal});
      document.addEventListener('shopify:section:select', event => {
        if (event.target.contains(this)) this.hidden = false;
      }, {signal});
      this.reduced.addEventListener('change', () => this.queueBuild(), {signal});
      this.mobile.addEventListener('change', () => this.queueBuild(), {signal});
      document.addEventListener('visibilitychange', () => this.updateVisibility(), {signal});
      this.resize = new ResizeObserver(() => this.queueBuild());
      this.resize.observe(this.viewport); this.resize.observe(this.original);
      this.observer = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting; this.updateVisibility();
      });
      this.observer.observe(this);
      document.fonts.ready.then(() => { if (this.isConnected) this.queueBuild(); });
      this.build();
    }
    updateVisibility() { this.dataset.offscreen = String(document.hidden || !this.visible); }
    queueBuild() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.build());
    }
    copy(node) {
      const clone = node.cloneNode(true);
      clone.dataset.marqueeCopy = '';
      clone.setAttribute('aria-hidden', 'true');
      [clone, ...clone.querySelectorAll('*')].forEach(element => {
        element.removeAttribute('id'); element.removeAttribute('data-shopify-editor-block'); element.removeAttribute('data-marquee-original');
        if (element.matches('a,button,input,select,textarea,[tabindex]')) element.setAttribute('tabindex', '-1');
      });
      return clone;
    }
    build() {
      if (!this.isConnected) return;
      this.querySelectorAll('[data-marquee-copy]').forEach(node => node.remove());
      if (this.dataset.motion !== 'true' || this.reduced.matches) { this.dataset.ready = 'false'; return; }
      this.dataset.ready = 'true';
      const width = this.original.getBoundingClientRect().width;
      const viewport = this.viewport.clientWidth;
      if (!width || !viewport) return;
      const copies = Math.min(30, Math.max(1, Math.ceil(viewport / width)));
      for (let i = 1; i < copies; i++) this.group.append(this.copy(this.original));
      const distance = this.group.getBoundingClientRect().width;
      const speed = Math.max(10, Number(this.mobile.matches ? this.dataset.mobileSpeed : this.dataset.speed) || 40);
      this.style.setProperty('--marquee-distance', `${distance}px`);
      this.style.setProperty('--marquee-duration', `${distance / speed}s`);
      this.track.append(this.copy(this.group));
    }
    disconnectedCallback() {
      this.abort?.abort(); this.resize?.disconnect(); this.observer?.disconnect(); cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-product-film"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ikao-product-film'))customElements.define('ikao-product-film',class extends HTMLElement{
 connectedCallback(){
  this.querySelectorAll('.ifilm-description p').forEach(p=>{if(!p.textContent.trim()&&!p.querySelector('img,video,iframe'))p.remove();});
  this.abort=new AbortController();const signal=this.abort.signal;this.video=this.querySelector('video');this.button=this.querySelector('.ifilm-toggle');this.media=this.querySelector('.ifilm-media');this.sources=JSON.parse(this.querySelector('[data-film-sources]').textContent);this.manualPause=false;this.visible=false;
  this.auto=this.dataset.autoplay==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches&&!navigator.connection?.saveData;
  this.button.addEventListener('click',()=>{if(this.video.paused){this.manualPause=false;this.load();this.video.play().catch(()=>{});}else{this.manualPause=true;this.video.pause();}},{signal});
  this.video.addEventListener('playing',()=>{this.media.dataset.loaded='true';this.button.setAttribute('aria-label',this.button.dataset.pause);this.button.firstElementChild.textContent='Ⅱ';},{signal});
  this.video.addEventListener('pause',()=>{this.button.setAttribute('aria-label',this.button.dataset.play);this.button.firstElementChild.textContent='▶';},{signal});
  this.video.addEventListener('error',()=>{this.media.dataset.loaded='false';},{signal});
  this.near=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){if(this.auto)this.load();this.near.disconnect();}},{rootMargin:'200px'});this.near.observe(this.media);
  this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:0.15});this.observer.observe(this.media);
  document.addEventListener('visibilitychange',()=>this.sync(),{signal});
 }
 load(){if(this.video.getAttribute('src'))return;const list=innerWidth<750?this.sources.mobile:this.sources.desktop;const mp4=list.filter(s=>s.mime_type==='video/mp4'||s.format==='mp4').sort((a,b)=>a.height-b.height);const target=innerWidth<750?720:1080;const source=mp4.find(s=>s.height>=target)||mp4[mp4.length-1];if(!source)return;this.video.src=source.url;this.video.muted=true;this.video.load();}
 sync(){if(!this.visible||document.hidden){this.video.pause();return;}if(this.auto&&!this.manualPause){this.load();this.video.play().catch(()=>{});}}
 disconnectedCallback(){this.abort?.abort();this.near?.disconnect();this.observer?.disconnect();this.video?.pause();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-product-rail"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('ikao-product-rail'))customElements.define('ikao-product-rail',class extends HTMLElement{
    connectedCallback(){this.track=this.querySelector('.ikao-rail__track');this.buttons=[...this.querySelectorAll('[data-direction]')];this.querySelector('.ikao-rail__arrows')?.removeAttribute('hidden');this.abort=new AbortController();const signal=this.abort.signal;this.refresh=()=>this.buttons.forEach(b=>{b.disabled=b.dataset.direction==='-1'?this.track.scrollLeft<2:this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;});this.buttons.forEach(b=>b.addEventListener('click',()=>this.track.scrollBy({left:Number(b.dataset.direction)*this.track.clientWidth*.9,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'}),{signal}));this.track.addEventListener('scroll',this.refresh,{passive:true,signal});this.resize=new ResizeObserver(this.refresh);this.resize.observe(this.track);this.refresh();}
    disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-product-suggestions"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ikao-product-suggestions'))customElements.define('ikao-product-suggestions',class extends HTMLElement{
  connectedCallback(){this.abort=new AbortController();this.hidden=false;this.style.minHeight='1px';this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.observer.disconnect();this.load();}},{rootMargin:'300px'});this.observer.observe(this);}
  async load(){const grid=this.querySelector('[data-suggestions-grid]');try{if(this.dataset.kind==='related'){if(!grid.querySelector('article')){const res=await fetch(this.dataset.url,{signal:this.abort.signal});if(!res.ok)throw Error();const doc=new DOMParser().parseFromString(await res.text(),'text/html');grid.append(...doc.querySelectorAll('[data-suggestions-grid] > article'));}}else{let handles=[];try{handles=JSON.parse(localStorage.getItem('ikao:recent:v1')||'[]');}catch{}if(!Array.isArray(handles))handles=[];handles=[...new Set(handles)].filter(h=>typeof h==='string'&&h!==this.dataset.current&&/^[a-z0-9%_-]+$/i.test(h)).slice(0,12);const results=await Promise.allSettled(handles.map(async handle=>{const url=this.dataset.root.replace(/\/$/,'')+'/products/'+encodeURIComponent(handle)+'?section_id=ikao-card-fragment';const res=await fetch(url,{signal:this.abort.signal});if(!res.ok)return null;return new DOMParser().parseFromString(await res.text(),'text/html').querySelector('article');}));const seen=new Set([this.dataset.currentId]);let count=0;results.forEach(r=>{if(r.status!=='fulfilled'||!r.value)return;const id=r.value.dataset.productId;if(!id||seen.has(id)||count>=Number(this.dataset.limit))return;seen.add(id);grid.append(r.value);count++;});}this.hidden=!grid.querySelector('article');document.dispatchEvent(new CustomEvent('ikao:cards:refresh'));}catch{this.hidden=!grid.querySelector('article');}}
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-shop-the-look"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ikao-shop-look'))customElements.define('ikao-shop-look',class extends HTMLElement{
 connectedCallback(){
  this.abort=new AbortController();const signal=this.abort.signal;this.hover=matchMedia('(hover:hover) and (pointer:fine)');
  this.querySelectorAll('[data-look-price]').forEach(el=>{try{el.textContent=new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency:el.dataset.currency}).format(Number(el.dataset.lookPrice)/100);}catch{}});
  this.querySelectorAll('.isl-hotspot').forEach(spot=>{
   const dot=spot.querySelector('.isl-dot');dot.addEventListener('click',()=>{if(spot.classList.contains('is-open'))this.close();else this.open(spot);},{signal});
   dot.addEventListener('focus',()=>{if(this.hover.matches&&dot.matches(':focus-visible'))this.open(spot);},{signal});
   spot.addEventListener('pointerenter',()=>{clearTimeout(this.leave);if(this.hover.matches)this.open(spot);},{signal});
   spot.addEventListener('pointerleave',()=>{if(this.hover.matches)this.leave=setTimeout(()=>{if(!spot.contains(document.activeElement))this.close();},180);},{signal});
   spot.querySelector('.isl-close').addEventListener('click',()=>{this.close();dot.focus();this.close();},{signal});
   spot.addEventListener('focusout',e=>{if(!spot.contains(e.relatedTarget))this.close();},{signal});
  });
  document.addEventListener('pointerdown',e=>{if(this.active&&!this.active.contains(e.target))this.close();},{signal});
  this.addEventListener('keydown',e=>{if(e.key==='Escape'&&this.active){const dot=this.active.querySelector('.isl-dot');dot.focus();this.close();}},{signal});
  this.resize=new ResizeObserver(()=>{if(this.active)this.position(this.active);});this.resize.observe(this);
  this.querySelector('.isl-grid')?.addEventListener('scroll',()=>this.close(),{signal,passive:true});
  this.end=this.toInstant(this.dataset.end,this.dataset.time);
  if(this.dataset.countdown==='true'&&this.querySelector('.isl-clock')){
   if(Number.isFinite(this.end)){this.tick();if(this.end>Date.now())this.timer=setInterval(()=>{if(!document.hidden)this.tick();},1000);document.addEventListener('visibilitychange',()=>this.tick(),{signal});}
   else if(this.dataset.editor==='true'){const note=this.querySelector('.isl-editor-note');note.hidden=false;note.textContent='Geri sayım için geçerli bitiş tarihi ve saati girin.';}
  }
 }
 open(spot){clearTimeout(this.leave);this.close();this.active=spot;spot.classList.add('is-open');spot.querySelector('.isl-dot').setAttribute('aria-expanded','true');spot.querySelector('.isl-popover').hidden=false;this.position(spot);}
 close(){if(!this.active)return;this.active.classList.remove('is-open');this.active.querySelector('.isl-dot').setAttribute('aria-expanded','false');this.active.querySelector('.isl-popover').hidden=true;this.active=null;}
 position(spot){const stage=spot.closest('.isl-stage').getBoundingClientRect(),point=spot.getBoundingClientRect(),panel=spot.querySelector('.isl-popover');const width=Math.min(300,stage.width-16);panel.style.setProperty('--pop-width',width+'px');const box=panel.getBoundingClientRect();let x=Math.max(stage.left+8,Math.min(point.left-width/2,stage.right-width-8));let y=point.top+24;if(y+box.height>stage.bottom-8)y=point.top-box.height-24;y=Math.max(stage.top+8,Math.min(y,Math.max(stage.top+8,stage.bottom-box.height-8)));panel.style.setProperty('--pop-x',(x-point.left)+'px');panel.style.setProperty('--pop-y',(y-point.top)+'px');}
 tick(){const clock=this.querySelector('.isl-clock');if(!clock)return;const seconds=Math.max(0,Math.ceil((this.end-Date.now())/1000));const ended=seconds===0;clock.hidden=ended&&this.dataset.expiry==='message';this.querySelector('.isl-expired').hidden=!clock.hidden;if(ended){clearInterval(this.timer);if(this.dataset.expiry==='hide_bar')this.querySelector('.isl-bar').hidden=true;}const vals={days:Math.floor(seconds/86400),hours:Math.floor(seconds/3600)%24,minutes:Math.floor(seconds/60)%60,seconds:seconds%60};clock.querySelectorAll('[data-time-unit]').forEach(e=>{const value=String(vals[e.dataset.timeUnit]).padStart(2,'0');if(e.textContent!==value)e.textContent=value;});}
 toInstant(date,time){if(!/^\d{4}-\d{2}-\d{2}$/.test(date)||!/^\d{2}:\d{2}$/.test(time))return NaN;const [y,m,d]=date.split('-').map(Number),[h,n]=time.split(':').map(Number),utc=Date.UTC(y,m-1,d,h,n),stamp=new Date(utc);if(stamp.getUTCFullYear()!==y||stamp.getUTCMonth()!==m-1||stamp.getUTCDate()!==d||h>23||n>59)return NaN;try{const fmt=new Intl.DateTimeFormat('en-GB',{timeZone:this.dataset.zone,year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});const local=t=>{const p=Object.fromEntries(fmt.formatToParts(new Date(t)).filter(x=>x.type!=='literal').map(x=>[x.type,Number(x.value)]));return Date.UTC(p.year,p.month-1,p.day,p.hour,p.minute,p.second);};let instant=utc;for(let i=0;i<4;i++){const delta=utc-local(instant);if(!delta)return instant;instant+=delta;}return local(instant)===utc?instant:NaN;}catch{return NaN;}}
 disconnectedCallback(){this.abort?.abort();this.resize?.disconnect();clearInterval(this.timer);clearTimeout(this.leave);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-support-hub"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ikao-support'))customElements.define('ikao-support',class extends HTMLElement{
 connectedCallback(){this.abort?.abort();this.abort=new AbortController();const signal=this.abort.signal;this.category='all';this.input=this.querySelector('[data-support-search]');this.items=[...this.querySelectorAll('[data-question]')];const normalize=s=>s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase().trim();const update=()=>{const words=normalize(this.input?.value||'').split(/\s+/).filter(Boolean);let count=0;this.items.forEach(d=>{const show=(this.category==='all'||d.dataset.topic===this.category)&&words.every(w=>normalize(d.textContent).includes(w));d.hidden=!show;if(show)count++;});this.querySelector('[data-empty]').hidden=count!==0;const results=this.querySelector('[data-results]');results.hidden=!words.length&&this.category==='all';results.textContent=count+' '+results.dataset.label;};this.querySelector('[data-search-ui]')?.removeAttribute('hidden');this.querySelector('[data-categories]').hidden=false;this.input?.addEventListener('input',update,{signal});this.querySelector('[data-clear]')?.addEventListener('click',()=>{this.input.value='';this.input.focus();update();},{signal});this.querySelectorAll('[data-category]').forEach(b=>b.addEventListener('click',()=>{this.category=b.dataset.category;this.querySelectorAll('[data-category]').forEach(x=>x.setAttribute('aria-pressed',String(x===b)));update();},{signal}));document.addEventListener('shopify:block:select',e=>{const d=e.target.closest('[data-question]');if(d&&this.contains(d)){this.category='all';if(this.input)this.input.value='';this.querySelectorAll('[data-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.category==='all')));update();d.open=true;}},{signal});}
 disconnectedCallback(){this.abort?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ikao-video-rail"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ikao-video-rail'))customElements.define('ikao-video-rail',class extends HTMLElement{
 connectedCallback(){queueMicrotask(()=>{if(this.isConnected)this.init();});}
 init(){
  this.abort=new AbortController();const signal=this.abort.signal;
  this.ready=false;this.visible=new Set();this.near=new Set();this.manual=new WeakSet();this.stopped=new WeakSet();
  this.reduced=matchMedia('(prefers-reduced-motion:reduce)');this.track=this.querySelector('.ivr-track');this.videos=[...this.querySelectorAll('video')];
  this.querySelectorAll('[data-vr-price]').forEach(el=>{try{el.textContent=new Intl.NumberFormat(document.documentElement.lang||'fr',{style:'currency',currency:el.dataset.currency}).format(Number(el.dataset.vrPrice)/100);}catch{}});
  const canAuto=()=>this.dataset.autoplay==='true'&&!this.reduced.matches&&!navigator.connection?.saveData;
  this.auto=canAuto;
  this.load=v=>{if(!v.getAttribute('src')){v.src=matchMedia('(max-width:749px)').matches?v.dataset.mobileSrc:v.dataset.src;v.muted=true;v.load();}};
  this.play=v=>{if(document.hidden||(!this.manual.has(v)&&(!this.auto()||this.stopped.has(v))))return;this.load(v);const promise=v.play();if(promise)promise.catch(()=>this.sync(v));};
  this.sync=v=>{const card=v.closest('.ivr-card'),button=card.querySelector('.ivr-toggle');card.classList.toggle('is-playing',!v.paused);button.setAttribute('aria-label',v.paused?this.dataset.play:this.dataset.pause);button.setAttribute('aria-pressed',String(!v.paused));button.firstElementChild.textContent=v.paused?'▶':'Ⅱ';};
  this.videos.forEach(v=>{
   const card=v.closest('.ivr-card');
   card.querySelector('.ivr-toggle').addEventListener('click',()=>{if(v.paused){this.stopped.delete(v);this.manual.add(v);this.play(v);}else{this.stopped.add(v);this.manual.delete(v);v.pause();}},{signal});
   ['play','pause','ended'].forEach(event=>v.addEventListener(event,()=>this.sync(v),{signal}));
   v.addEventListener('loadeddata',()=>card.classList.add('has-frame'),{signal});
   v.addEventListener('error',()=>{card.classList.remove('has-frame','is-playing');this.sync(v);},{signal});
  });
  this.nearObserver=new IntersectionObserver(records=>records.forEach(r=>{const v=r.target.querySelector('video');if(r.isIntersecting){this.near.add(v);if(this.ready&&this.auto())this.load(v);}else this.near.delete(v);}),{rootMargin:'180px 0px',threshold:.01});
  this.playObserver=new IntersectionObserver(records=>records.forEach(r=>{const v=r.target.querySelector('video');if(r.isIntersecting&&r.intersectionRatio>=.2){this.visible.add(v);if(this.ready)this.play(v);}else{this.visible.delete(v);v.pause();}}),{threshold:[0,.2]});
  this.videos.forEach(v=>{this.nearObserver.observe(v.closest('.ivr-card'));this.playObserver.observe(v.closest('.ivr-card'));});
  const arm=()=>{this.timer=setTimeout(()=>{this.ready=true;if(this.auto())this.near.forEach(this.load);this.visible.forEach(this.play);},Math.max(1000,Number(this.dataset.delay)||2000));};
  if(document.readyState==='complete')arm();else window.addEventListener('load',arm,{once:true,signal});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)this.videos.forEach(v=>v.pause());else if(this.ready)this.visible.forEach(this.play);},{signal});
  this.reduced.addEventListener('change',()=>{if(!this.auto())this.videos.forEach(v=>v.pause());else if(this.ready)this.visible.forEach(this.play);},{signal});
  const arrows=this.querySelector('.ivr-arrows'),prev=this.querySelector('[data-vr-prev]'),next=this.querySelector('[data-vr-next]');
  const update=()=>{arrows.hidden=this.track.scrollWidth<=this.track.clientWidth+2;prev.disabled=this.track.scrollLeft<=2;next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;};
  const move=direction=>this.track.scrollBy({left:direction*this.track.clientWidth*.85,behavior:this.reduced.matches?'instant':'smooth'});
  prev.addEventListener('click',()=>move(-1),{signal});next.addEventListener('click',()=>move(1),{signal});this.track.addEventListener('scroll',update,{passive:true,signal});this.resize=new ResizeObserver(update);this.resize.observe(this.track);update();
 }
 disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort();this.nearObserver?.disconnect();this.playObserver?.disconnect();this.resize?.disconnect();this.videos?.forEach(v=>{v.pause();v.removeAttribute('src');v.load();});}
});

  } catch(e) { console.error(e); }
})();
})();
